import { createBrowserRouter } from "react-router";
import Login from "../../pages/Login/Login";
import Dashboard from "../../pages/Dashboard/Dashboard";
import Bills from "../../pages/Bills/Bills";
import DetailBill from "../../pages/DetailBill/DetailBill";
import Viaticos from "../../pages/Viatocos/Viatocos";
import DetailViaticos from "../../pages/DetailViaticos/DetailViaticos";
import Reports from "../../pages/Reports/Reports";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/login",
    element: <Login />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/bills",
    element: <Bills />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/bills/:id",
    element: <DetailBill />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/viaticos",
    element: <Viaticos />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/viaticos/:id",
    element: <DetailViaticos />,
    errorElement: <p>error here</p>,
    children: [],
  },
  {
    path: "/reports",
    element: <Reports />,
    errorElement: <p>error here</p>,
    children: [],
  },
]);
